import React, { useEffect, useRef, useState } from 'react';
import { Card, CardBody, Col, Row, FormGroup, CardHeader, Button, TabContent, TabPane, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Label, Input } from 'reactstrap';
import formSchema from '../Utils/schema.json';
import { RenderField } from '../Utils/renderFields';
import { RenderErrorMessage } from '../Utils/renderErrorMessages';
import { LabelText } from '../Utils/Input';
import { userOptions } from './Constant/UserOptions';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import CommonModal from '../Utils/CommonModal';
import { handleChangePassword, handleRemoveLogo } from './Constant/JsonConstant';
import { renderStatusBadge } from './Constant/StatusBadge';
import { handleModalAction } from './Constant/handleModalAction';
import StatusBadge from '../Customers/StatusBadge';
import { ImageUpload } from '../Utils/ImageUpload';
import { getGroupedOptions } from './Constant/GetGroupedOptions';
import { useSelector } from 'react-redux';

export default function UserDetails({ profileData, setFileSelected, values, handleChange, handleBlur, errors, touched, setFieldTouched, setFieldValue, isEdit, user, userId, navigate, dispatch, setLoading, changePassword, imageOn, setImageOn, logoFile, setLogoFile, profile, setUpdate, documentName, modalOpen, setModalOpen, toggleModal, isStatus, setIsStatus,isUserPath,customRoles,isGroupedOptions,operatorUser, operatorId, onCancel  })  {
    const [activeTab, setActiveTab] = useState('1');
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [status, setStatus] = useState();
    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
    const fileInputRef = useRef(null);
    const roleName = localStorage.getItem("roleName")
    const userOptionsData = userOptions((roleName === "systemUser" && operatorUser) ? operatorUser : roleName)
    const environment = (localStorage.getItem("environment"));
    const isNativeEnvironment = environment === "Native";
    const isKeycloakEnvironment = environment === "Keycloak";
    const [validateSizeError, setValidateSizeError] = useState(null);
    const handleStatusChange = (newStatus) => {
        setStatus(newStatus);
        newStatus === (user?.status) ? setIsStatus(false) : setIsStatus(true)
    };

    const operatorConfiguration = useSelector(
        (state) =>
            state?.GetOperatorSpecificConfiguration?.OperatorSpecificConfiguration
    );
    const idps = operatorConfiguration?.configurations?.identityManagement?.value?.IdentityProvider?.value?.toString()?.split(",") || [];
    const otherIdp = idps?.find(idp => idp !== "Keycloak");

    useEffect(() => {
        if (changePassword) {
            setActiveTab('2');
        }
    }, [changePassword]);

    useEffect(() => {
        setStatus(user?.status || 'Active')
    }, [user?.status]);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const allowedFormats = ["image/jpeg", "image/png", "image/svg+xml"];
            if (!allowedFormats.includes(file.type)) {
                setValidateSizeError(
                    "Invalid file format. Please upload JPEG, PNG, or SVG."
                );
            } else if (file.size / (1024 * 1024) > 10) {
                setValidateSizeError("File size exceeds the limit (10MB)");
            } else {
                setLogoFile(file);
                setImageOn(true);
                setFileSelected(true)
            } }
        else {
            setLogoFile(null);
            setImageOn(false);
            setFileSelected(false)
        }
    };

    const handleSSOToggle = (e) => {
        setFieldValue('isSSOUser', e.target.checked);
    };

    // Helper function to get field helper text
    const getFieldHelperText = (field) => {
        const fieldName = field.name;
        if (touched[fieldName] && errors[fieldName]) {
            return errors[fieldName];
        }
        return `Enter ${field.label}`;
    };

    // Helper function to get label class for helper text
    const getHelperTextClass = (field) => {
        const fieldName = field.name;
        const baseClass = "d-block ms-0 rv-sub-label";
        if (touched[fieldName] && errors[fieldName]) {
            return `${baseClass} rv-label-danger`;
        }
        return `${baseClass} rv-label-muted`;
    };
    const defaultRoles = userOptionsData.find(option=>option.name==="userrole")?.options || []
    const groupedOptions=getGroupedOptions(defaultRoles, customRoles);
    
    return (
        <div className="live-preview">
            <TabContent activeTab={activeTab}>
                {!changePassword && (
                    <TabPane tabId="1" >
                        {formSchema.map((section, sectionIndex) => (
                            <React.Fragment key={sectionIndex}>
                                {section.title === "User" && section.sections &&
                                    section.sections.map((subSection, subSectionIndex) => (
                                        subSection.sectionTitle !== "Password Change" && (
                                            <div key={subSectionIndex}>
                                                {subSection?.sectionTitle && (
                                                    <>
                                                        {isEdit && (
                                                            <div className=" d-flex align-items-center ms-n1">
                                                                <h4 className="card-title mb-4 flex-grow-1 d-flex justify-content-start align-items-center ms-n1">
                                                                    {isEdit && subSection?.sectionTitle === "User Information" && (
                                                                        <>
                                                                            <div>
                                                                                <span style={{ marginLeft: '10px' }}>
                                                                                    <StatusBadge value={user?.status?.charAt(0).toUpperCase() + user?.status?.slice(1).toLowerCase()} />
                                                                                </span>
                                                                            </div>

                                                                            <FormGroup switch className="mb-1 ms-2 flex-grow-1 justify-content-between align-items-center switch-state">
                                                                                <div className="me-2">
                                                                                    <Input
                                                                                        className={
                                                                                            "d-flex border border-danger bg-danger-subtle text-danger rv-form-switch-input"
                                                                                        }
                                                                                        type={"switch"}
                                                                                        checked={
                                                                                            status === "active" || status === "Active"
                                                                                        }
                                                                                        onChange={() =>
                                                                                            handleStatusChange(
                                                                                                status === "active" || status === "Active"
                                                                                                    ? "inactive"
                                                                                                    : "active"
                                                                                            )
                                                                                        }
                                                                                    />
                                                                                </div>
                                                                            </FormGroup>
                                                                        </>
                                                                    )}
                                                                </h4>
                                                            </div>
                                                        )}
                                                    </>
                                                )}
                                                <CardBody>
                                                    <Row className='gy-4'>
                                                        <Col lg={12}>
                                                            <Row className='gy-2'>
                                                                {subSection.fields.filter(field => {
                                                                    if (isEdit && (field.name === "username" || field.name === "email" || field.name === "userrole")) {
                                                                        field.disable = true;
                                                                    } else {
                                                                        field.disable = false;
                                                                    }
                                                                    if (field.name === "status" && !isEdit) {
                                                                        return false;
                                                                    }
                                                                    return true;
                                                                }).map((field, fieldIndex) => (
                                                                    <Col xxl={4} md={6} lg={4} key={`${subSectionIndex}-${fieldIndex}`} className="pe-0">
                                                                        <div>
                                                                            <FormGroup>
                                                                                {/* Main Label */}
                                                                                <LabelText
                                                                                    htmlFor={field.name}
                                                                                    classLabelName={"ms-0 rv-form-label"}
                                                                                    className={field.required ? "text-danger" : ""}
                                                                                    displayText={field.label}
                                                                                    important={field.required ? "*" : ""}
                                                                                />

                                                                                {/* Helper Text Label */}
                                                                                <LabelText
                                                                                    htmlFor={field.name}
                                                                                    classLabelName={getHelperTextClass(field)}
                                                                                    displayText={getFieldHelperText(field)}
                                                                                />

                                                                                {/* Field Input */}
                                                                                {field.type === 'phone' ? (
                                                                                    <PhoneInput
                                                                                        international
                                                                                        countryCallingCodeEditable={false}
                                                                                        className={`form-control ${touched[field.name] && errors[field.name] ? 'error-input' : ''}`}
                                                                                        placeholder={field.placeholder}
                                                                                        value={values[field.name]}
                                                                                        onChange={(value) => setFieldValue(field.name, value)}
                                                                                        onBlur={() => setFieldTouched(field.name, true)}
                                                                                        disabled={field?.autoload && field.isEdit}
                                                                                    />
                                                                                ) : (
                                                                                    <RenderField
                                                                                        field={field}
                                                                                        handleChange={handleChange}
                                                                                        handleBlur={handleBlur}
                                                                                        values={values}
                                                                                        touched={touched}
                                                                                        errors={errors}
                                                                                        setFieldTouched={setFieldTouched}
                                                                                        setFieldValue={setFieldValue}
                                                                                        options={isGroupedOptions?groupedOptions:userOptionsData}
                                                                                        useGroupedOptions={isUserPath && isGroupedOptions?true:false}
                                                                                    />
                                                                                )}
                                                                            </FormGroup>
                                                                        </div>
                                                                    </Col>
                                                                ))}
                                                            </Row>
                                                        </Col>
                                                        {((!isNativeEnvironment && !idps?.includes("Keycloak")) && (operatorUser !== "SGCExecutiveUser" || operatorUser !== "SGCPowerUser" || operatorUser !== "SGCOperationsUser"))?
                                                            <Col xxl={6} md={6} lg={6}>
                                                                <div className='mt-n2'>
                                                                    <FormGroup>
                                                                        <LabelText htmlFor={"sso"} className={"text-danger"} displayText={"SSO"} />
                                                                        <div className="d-flex align-items-center">
                                                                            <FormGroup switch >
                                                                                <Input
                                                                                    type={"switch"}
                                                                                    className="rv-form-switch-input"
                                                                                    name="isSSOUser"
                                                                                    checked={values.isSSOUser || false}
                                                                                    onChange={handleSSOToggle}
                                                                                    disabled={isEdit}
                                                                                />
                                                                            </FormGroup>
                                                                        </div>
                                                                    </FormGroup>
                                                                </div>
                                                            </Col> : null}
                                                        {(idps?.includes("Keycloak") && idps?.length > 1) ? 
                                                            <Col>
                                                                <div className='mt-n2'>
                                                                    <FormGroup>
                                                                        <LabelText htmlFor={"sso"} className={"text-danger"} displayText={`${otherIdp} SSO`} />
                                                                        <div className="d-flex align-items-center">
                                                                            <FormGroup switch >
                                                                                <Input
                                                                                    type={"switch"}
                                                                                    className="rv-form-switch-input"
                                                                                    name="sso"
                                                                                    checked={values.isSSOUser || false}
                                                                                    onChange={handleSSOToggle}
                                                                                    disabled={isEdit}
                                                                                />
                                                                            </FormGroup>
                                                                        </div>
                                                                    </FormGroup>
                                                                </div>
                                                            </Col>
                                                        : null }
                                                        <Col lg={12}>
                                                            <ImageUpload
                                                                validateSizeError={validateSizeError}
                                                                profilePicture={logoFile}
                                                                isProfile={imageOn}
                                                                inputFileRef={fileInputRef}
                                                                removeProfilePicture={() => {
                                                                    handleRemoveLogo(dispatch, setLoading, setLogoFile, setImageOn, setUpdate, fileInputRef, documentName, userId, isEdit)
                                                                    setValidateSizeError(null)
                                                                }}
                                                                handleImageChange={(e) => {
                                                                    handleFileChange(e)

                                                                }}
                                                            ></ImageUpload>
                                                        </Col>

                                                    </Row>
                                                </CardBody>
                                            </div>
                                        )
                                    ))}
                            </React.Fragment>
                        ))}
                    </TabPane>
                )}
                {changePassword && (
                    <TabPane tabId="2" className='mt-3'>
                        {formSchema.map((section, sectionIndex) => (
                            <React.Fragment key={sectionIndex}>
                                {section.title === "User" && section.sections &&
                                    section.sections.map((subSection, subSectionIndex) => (
                                        subSection.sectionTitle === "Password Change" && (
                                            <Card key={subSectionIndex}>
                                                {subSection?.sectionTitle && (
                                                    <CardHeader className="align-items-center d-flex">
                                                        <h4 className="card-title mb-0 flex-grow-1">
                                                            {subSection?.sectionTitle}
                                                        </h4>
                                                    </CardHeader>
                                                )}
                                                <CardBody className='mb-2'>
                                                    <Row className='gy-4'>
                                                        <div>Enter a new password below to change your password.</div>
                                                        {subSection.fields.map((field, fieldIndex) => (
                                                            <Col xxl={4} md={6} lg={4} key={`${subSectionIndex}-${fieldIndex}`} className="pe-0">
                                                                <div>
                                                                    <FormGroup>
                                                                        {/* Main Label */}
                                                                        <LabelText
                                                                            htmlFor={field.name}
                                                                            classLabelName={"ms-0 rv-form-label"}
                                                                            className={field.required ? "text-danger" : ""}
                                                                            displayText={field.label}
                                                                            important={field.required ? "*" : ""}
                                                                        />

                                                                        {/* Helper Text Label */}
                                                                        <LabelText
                                                                            htmlFor={field.name}
                                                                            classLabelName={getHelperTextClass(field)}
                                                                            displayText={getFieldHelperText(field)}
                                                                        />

                                                                        {/* Field Input */}
                                                                        <RenderField
                                                                            field={field}
                                                                            handleChange={handleChange}
                                                                            handleBlur={handleBlur}
                                                                            values={values}
                                                                            touched={touched}
                                                                            errors={errors}
                                                                            setFieldTouched={setFieldTouched}
                                                                            setFieldValue={setFieldValue}
                                                                            options={userOptionsData}
                                                                        />
                                                                    </FormGroup>
                                                                </div>
                                                            </Col>
                                                        ))}
                                                        <Col lg={4} className="d-flex align-items-end">
                                                            <Button color="primary" type='submit' onClick={() => { if (changePassword && values.newPassword !== "" && values.confirmNewPassword !== "") { handleChangePassword(values, dispatch, setLoading, navigate, userId) } }}>
                                                                Change Password
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                </CardBody>
                                            </Card>
                                        )
                                    ))}
                            </React.Fragment>
                        ))}
                    </TabPane>
                )}
            </TabContent>
            <CommonModal
                toggle={toggleModal}
                open={modalOpen}
                messageForPopUp={status === 'active' ? `Are you sure you want to Activate this User?` : `Are you sure you want to Deactivate this User?`}
                buttonText="Confirm"
                modalAction={() =>
                    handleModalAction({ values, status, setLoading, navigate, userId, dispatch, toggleModal, operatorId, onCancel })}
                closeButtonText="Close"
                fromCustomer="Customer"
                closeButtonAction={toggleModal}
            />
        </div>
    );
}